import React, { useState, useEffect } from 'react'
import { ChevronUpIcon } from '@heroicons/react/24/outline'

interface ScrollToTopProps {
  threshold?: number
  className?: string
}

const ScrollToTop: React.FC<ScrollToTopProps> = ({ 
  threshold = 300,
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > threshold) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility, { passive: true })

    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [threshold])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-6 right-6 z-50
        w-12 h-12 rounded-full
        bg-white/90 backdrop-blur-sm
        shadow-lg shadow-gray-200/50
        border border-gray-100
        flex items-center justify-center
        text-gray-600 hover:text-indigo-600
        hover:shadow-xl hover:-translate-y-1
        transition-all duration-300
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}
        ${className}
      `}
      aria-label="滚动到顶部"
    >
      <ChevronUpIcon className="w-5 h-5" />
    </button>
  )
}

export default ScrollToTop;
